import StorageMartHours from './StorageMartHours';

export default StorageMartHours;
